module.exports = __webpack_public_path__ + "img/locations_tiny.c8543a13.png";